// 景别类型（基于国际影视行业标准）
export const SHOT_TYPES = [
  { value: 'extreme_wide_shot', label: '大远景' },
  { value: 'wide_shot', label: '远景' },
  { value: 'full_shot', label: '全景' },
  { value: 'medium_shot', label: '中景' },
  { value: 'medium_close_up', label: '中近景' },
  { value: 'close_up', label: '特写' },
  { value: 'extreme_close_up', label: '大特写' },
  { value: 'over_shoulder', label: '过肩镜头' },
];

// 运镜类型（基于国际影视行业标准）
export const CAMERA_MOVEMENTS = [
  { value: 'static', label: '固定' },
  { value: 'pan', label: '摇镜' },
  { value: 'tilt', label: '俯仰' },
  { value: 'dolly', label: '推拉' },
  { value: 'zoom', label: '变焦' },
  { value: 'tracking', label: '跟踪' },
  { value: 'arc', label: '环绕' },
  { value: 'crane', label: '升降' },
  { value: 'handheld', label: '手持' },
];

const SHOT_TYPE_LABEL_MAP = new Map(SHOT_TYPES.map((item) => [item.value, item.label]));
const CAMERA_MOVEMENT_LABEL_MAP = new Map(CAMERA_MOVEMENTS.map((item) => [item.value, item.label]));

/** 仅用于展示，保留未知值与原始 payload。 */
export function getShotSizeLabel(value: string): string {
  return SHOT_TYPE_LABEL_MAP.get(value) ?? value;
}

export function getCameraMovementLabel(value: string): string {
  return CAMERA_MOVEMENT_LABEL_MAP.get(value) ?? value;
}
